export const PAGE_NOT_FOUND_MESSAGE = "The page you're looking for doesn't exist.";
export const PRO_FORMA_NOT_FOUND_MESSAGE = "The pro forma you're looking for doesn't exist.";
